<template>
  <div class="home">
    CONTACT PAGE
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Contact'
}
</script>
